export default {
    'Sí':'Sí',
    'no' : 'no',
    'id': 'Id',
    'nombre': 'Nombre',
    'telefono': 'Teléfono',
    'codigo': 'Código',
    'email': 'Email',
    'activo': 'Activo',
    'estado': 'Estado',
    'descripcion': 'Descripción',
    'usuario': 'Usuario',
    'clave': 'Clave',
    'all': 'Todos',
    'false': 'No',
    'true': 'Sí',
    'contact-form-send': "Formulario enviado con éxito",
    'rows-per-page': 'Filas por página:',
    'rules': {
        'required': 'El campo es requerido',
        'email': 'El campo no cumple con el formato correcto'
    },
    'home': {
        'titulo': 'Bienvenido',
        'parrafo': 'Ha instalado correctamente la plantilla del ITI para agilizar nuevos desarrollos de software con tecnología .Net (Core) y VueJS. Antes de empezar le invitamos a consultar toda la información puesta a su disposición en las guías de inicio.',
        'enlaces': 'Enlaces de interés',
        'front': 'Guía de inicio Web',
        'back': 'Guía de inicio Backend',
    },
    'menu': {
        'seguridad': 'Seguridad',
        'usuarios': 'Usuarios',
        'roles': 'Roles',
        'administracion': 'Administración',
        'tareas-programadas': 'Tareas Programadas',
        'inicio-publica': 'Zona pública',
        'inicio-privada': 'Home',
        'insylay': 'Portal Insylay',
        'buscador-avanzado': 'Buscador avanzado'
    },
    'menu-tooltip': {
        'areas-publicas': 'Temáticas de interés general',
        'grupos-trabajo': 'Temática específica donde colaboran los expertos sectoriales y los colaboradores',
        'areas-colaborativas': 'Proyectos de colaboración entre empresas'
    },
    'menuavatar': {
        'perfil': 'Perfil de usuario',
        'salir': 'Salir',
        'salir-confirmacion': "¿Está seguro de salir?"
    },
    'maestros': {
        'buscar': 'Buscar',
        'buscarPor': 'Filtrar por',
        'descargar': 'Descargar',
        'no-results': 'No hay resultados para la búsqueda',
        'activo': 'Activo',
        'admin': 'Admin',
        'editar': 'Editar',
        'eliminar': 'Eliminar',
        'mostrar': 'Mostrar',
        'pagina': 'Página',
        'filRow': 'Noticias por página',
        'explorar': 'Explorar',
    },
    'algoritmo': {
        'algoritmo': 'Algoritmo',
        'algoritmos': 'Algoritmos',
        'codigo': 'Código',
        'descripcion': 'Descripción',
        'imagen': 'Imagen docker',
        'estado': 'Estado',
        'registrado': 'Registrado',
        'punto-entrada': 'Punto entrada',
        'variables-entorno': 'Variables de entorno',
        'nombre-modulo': 'Nombre del módulo',
        'entrada': 'Entrada',
        'salida': 'Salida',
        'slots': 'Container Slots',
        'categorias': 'Categorías',
        'tipo-lanzamiento': 'Lanzamiento',
        'nuevo-algoritmo': 'Nuevo algoritmo',
        'registrar': 'Registrar',
        'desregistrar': 'Desregistrar',
        'activar': 'Activar',
        'desactivar': 'Desactivar'
    },
    'maestro-usuarios': {
        'usuario': 'Usuario',
        'email': 'Email',
        'clave': 'Clave',
        'repetir-clave': 'Repetir clave',
        'cambiar-clave': 'Cambiar clave',
        'roles': 'Roles',
        'id-externo': 'ID Externo',
        'razon-social': 'Razón social',
        'provincia': 'Provincia',
        'direccion': 'Dirección',
        'poblacion': 'Población',
        'codigo-postal': 'Código postal',
        'pais': 'País',
        'cif': 'CIF',
    },
    'maestro-roles': {
        'rol': 'Rol',
        'nombre': 'Nombre',
    },
    'maestro-tareas': {
        'tareas-programadas': 'Tareas Programadas',
        'tarea-programada': 'Tarea Programada',
        'timeout': 'Tiempo máximo (min)',
        'tipo-tarea': 'Tipo de tarea',
        'inicio-automatico': 'Inicio automático',
        'cada': 'Cada',
        'minutos': 'minutos',
        'horas': 'horas',
        'cron': 'Periodicidad',
        'iniciar': 'Iniciar',
        'detener': 'Detener',
        'en-ejecucion': 'En ejecución',
    },
    'maestro-configuracion': {
        'codigo-cnae': 'Código Cnae',
        'codigo-ler': 'Código Ler',
        'sector': 'Sector',
        'tipo-unidad': 'Tipo Unidad',
        'tipo-campo': 'Tipo Campo',
        'asociacion': 'Asociación',
        'categoria': 'Categoría',
        'categoria-primer-nivel': 'Categoría primer nivel',
        'categoria-segundo-nivel': 'Categoría segundo nivel',
        'categoria-tercer-nivel': 'Categoría tercer nivel',
        'categoria-cuarto-nivel': 'Categoría cuarto nivel',
        'primer-nivel': 'Primer nivel',
        'segundo-nivel': 'Segundo nivel',
        'tercer-nivel': 'Tercer nivel',
        'cuarto-nivel': 'Cuarto nivel',
        'codigo': 'Código',
        'descripcion': 'Descripción',
        'tipo': 'tipo',
        'externalID': 'ID Externo',
    },
    'mensajes': {
        'save-ok': 'Cambios realizados correctamente',
        'ok': ' guardado correctamente',
        'confirmar': 'Confirmación',
        'pregunta-borrar': '¿ Está seguro que quiere eliminar "',
        'error-session': 'La sesión ha expirado',
        'error-categoria-padre-vacia': 'La categría padre no puede estar vacía'
    },
    'header-footer': {
        'inicio': 'Inicio',
        'proyecto': 'El proyecto',
        'simbiosis': 'Simbiosis Industrial',
        'casos': 'Casos de éxito',
        'actualidad': 'Actualidad',
        'indicadores': 'Indicadores',
        'contacto': 'Contacto',
        'avisoLegal': 'Aviso legal',
        'cookies': 'Política de cookies',
        'politicaPrivacidad': 'Política de privacidad',
        'private': 'Zona Privada',
        'observatorio': 'Observatorio',
        'demostrador': 'Demostrador',
    },
    'inicio': {
        'calltoaction-placeholder-1': 'Oferta, demanda o ambas',
        'calltoaction-placeholder-2': 'Describe tu oferta, demanda o ambas',
        'sinergias': 'Buscar sinergias',
        'como-funciona': '¿Cómo funciona?',
        'feature-1': 'Indicas los recursos que ofreces',
        'feature-2': 'El sistema localiza sinergías',
        'feature-3': 'Contacta y llega a acuerdos',
        'empezar': 'Empezar',
        'subscribe-text': 'Empieza ya a ofertar o demandar esos recursos sin uso',
        'contacto': 'Contacto',
        'nombre': 'Nombre completo',
        'email': 'Email',
        'asunto': 'Asunto',
        'mensaje': 'Tu mensaje',
        'enviar': 'Enviar',
        'seleccionar': 'Seleccionar',
    },
    'plantillas': {
        'plantilla': 'Plantilla',
        'plantillas': 'Plantillas',
        'listaPlantillas': 'Lista Plantillas',
        'nuevaPlantilla': 'Nueva Plantilla',
        'id': 'Id',
        'title': 'Título',
        'description': 'Descripción',
        'lerCodeCode': 'Ler Code',
        'sectorCode': 'Sector Code',
        'cnaeCodeCode': 'Cnae Code',
        'ler': 'LER',
        'sector': 'Sector',
        'cnae': 'CNAE',
        'category': 'Categoría',
        'level1': 'Nivel 1',
        'level2': 'Nivel 2',
        'level3': 'Nivel 3',
        'level4': 'Nivel 4',
        'campos': 'Campos',
        'nuevoCampo': 'Nuevo campo',
        'fieldCode': 'Identificador',
        'fieldLabel': 'Etiqueta',
        'fieldTypecode': 'Tipo',
        'fieldDescription': 'Descripción',
        'fieldType': 'Tipo de Campo',
        'unitType': 'Unidades',
        'defaultValue': 'Valor por defecto',
        'obligatory': 'Obligatorio',
        'help': 'Ayuda',
        'validationRules': 'Reglas de validación',
        'errorMessage': 'Mensaje de error',
        'minimum': 'Mínimo',
        'maximum': 'Máximo',
        'value': 'Valor',
        'listaValores': 'Lista de Valores',
        'editarListado': 'Para editar el listado haga clic',
        'version': 'Versión',
        'oferta': 'Oferta',
        'demanda': 'Demanda',
        'ofertaOdemanda': 'Oferta o Demanda',
        'lastModification': 'Última fecha de modificación',
        'tipo': 'Tipo',
        'rowsPage': 'Filas por página',
        'autor': 'Autor',
        'readOnly': 'Solo lectura',
        'tooltip-rules': 'Expresión regular para validar el contenido del campo introducido por el usuario. Ejemplo: /^([0-9])*$/',
        'solo-activas' : 'Solo activas'
    },
    'versiones': {
        'descripcion': 'Descripción',
        'version': 'Versión',
        'activo': 'Activo',
        'publicado': 'Publicado',
        'nuevaVersionCopia': 'Crear nueva versión a partir de esta',
        'activar': 'Activar',
        'desactivar': 'Desctivar',
        'publicar': 'Publicar',
    },
    'mensajes-plantillas': {
        'save-ok': 'Cambios realizados correctamente',
        'ok': ' Guardado correctamente',
        'confirmar': 'Confirmación',
        'incorrecto': 'Incorrecto',
        'pregunta-borrar-plantilla': '¿ Está seguro que quiere eliminar la plantilla ?',
        'pregunta-borrar-campo': '¿ Está seguro que quiere eliminar el campo ?',
        'pregunta-borrar-version': '¿ Está seguro que quiere eliminar la versión ?',
        'pregunta-salir': '¿ Está seguro que desea salir ? Perderá todos los cambios realizados',
        'pregunta-guardar': '¿ Desea guardar todos los cambios realizados ?',
        'info-eliminar': 'Se ha eliminado correctamente',
        'info-crear': 'Se ha creado correctamente',
        'info-modificar': 'Se ha modificado correctamente',
        'info-error': 'Se ha producido un error, vuelva a intentarlo',
        'info-valida': 'Seleccione una opción válida',
        'info-sinCampos': 'Debe crear un campo como mínimo',
        'faltan-campos': 'Faltan campos por completar',
        'campos-sin-guardar': '¿ Seguro que quiere salir ? El último campo modificado no se ha guardado',
        'info-category': 'Selecciona una categoría',
        'info-error-oferta-demanda' : 'Se debe seleccionar si la plantilla es de oferta, demanda o ambos',
        'pregunta-activar-version' : 'Al activar una versión, se desactivarán las otras versiones. ¿Desea continuar?',
        'pregunta-publicar-version' : 'Al publicar una versión, ya no se permite su edición o eliminación. ¿Desea continuar con la publicación?',
    },
    'mensajes-algoritmos': {
        'info-error': 'Se ha producido un error, vuelva a intentarlo',
        'info-eliminar': 'Se ha eliminado correctamente',
        'pregunta-borrar-algoritmo': '¿ Está seguro que quiere eliminar el algoritmo ?',
        'pregunta-guardar': '¿ Desea guardar todos los cambios realizados ?',
        'ok': ' Guardado correctamente',
        'info-category': 'Selecciona una categoría',
        'pregunta-salir': '¿ Está seguro que desea salir ? Perderá todos los cambios realizados',
    },
    'botones': {
        'guardar': 'Guardar',
        'cancelar': 'Cancelar',
        'editar': 'Editar',
        'editarPlantilla': 'Editar plantilla',
        'nuevoCampo': 'Nuevo Campo',
        'nuevaVersion': 'Nueva Versión',
        'subir': 'Subir',
        'bajar': 'Bajar',
        'cerrar': 'Cerrar',
        'volver': 'Volver',
        'aqui': 'aquí',
        'crear': 'Crear',
        'activate': 'Activar',
        'deactivate': 'Desactivar'
    },
    'vee-validate': {
        'required': 'Este campo no se puede dejar vacio',
        'lerCode': 'El código LER no es correcto',
        'sectorCode': 'El código del Sector no es correcto',
        'cnaeCode': 'El código CNAE no es correcto',
        'categoryCode': 'El código de la Categoría no es correcto',
        'fieldTypeCode': 'El Tipo de Campo no es correcto',
        'unitTypeCode': 'El Tipo de Unidad no es correcto',
        'length': 'Este campo no puede ser mayor de ',
        'characters': ' caracteres',
        'valorMaximo': 'El valor máximo debe ser mayor que el valor mínimo'
    },
    'chat': {
        'ROOMS_EMPTY': 'No hay chats',
        'ROOM_EMPTY': 'Ningún chat seleccionado',
        'NEW_MESSAGES': 'Nuevos mensajes',
        'MESSAGE_DELETED': 'Este mensaje ha sido eliminado',
        'MESSAGES_EMPTY': 'No hay mensajes',
        'CONVERSATION_STARTED': 'La conversación empieza el :',
        'TYPE_MESSAGE': 'Escriba su mensaje',
        'SEARCH': 'Buscar',
        'IS_ONLINE': 'En línea',
        'LAST_SEEN': 'Última conexión ',
        'IS_TYPING': 'está escribiendo...',
        'nuevaSalaTitulo': 'Crear chat para nueva área colaborativa',
        'enviarMensajeBoton': 'Enviar'
    },
    'notificaciones': {
        'tabNotificaciones': 'Notificaciones',
        'leido': 'Leído',
        'leerSala': 'Marcar notificaciones sala como leidas',
        'ver': 'Ver',
        'mensajeDe': 'Mensaje de ',
        'sinergias': 'Notificación de sinergías',
        'chat': 'Nuevo mensaje de chat',
        'documento': 'Nuevo documento',
        'evento': 'Nuevo evento',
        'foro': 'Nuevo mensaje de foro',
        'default': 'Nueva notificación',
        'leerTodo': 'Marcar todo como leido',
        'sistema': 'Notificación del sistema',
        'errorOrigen': 'Error obteniendo origen mensaje',
        'noHayNotificacion': 'No hay notificacion cargada',
        'notificacionesNoLeidas': 'Notificaciones no leidas',
        'notificacionesLeidas': 'Notificaciones leidas',
        'enviarMensajeBoton': 'Enviar',
        'enviarMensajeTitulo': 'Enviar mensaje'
    },
    'collaborative-area': {
        'myCollaborativeAreas': 'Mis áreas colaborativas',
        'collaborativeAreas': 'Áreas colaborativas',
        'collaborativeArea': 'Área Colaborativa',
        'publicArea': 'Áreas públicas',
        'workGroups': 'Grupos de trabajo',
        'privateArea': 'Áreas privadas',
        'info': 'Información Área Colaborativa',
        'nameArea': 'Nombre área',
        'numUsers': 'Nº usuarios',
        'numFiles': 'Nº documentos',
        'file': 'Fichero',
        'date': 'Fecha',
        'fileDate': 'Fecha fichero',
        'messageDate': 'Fecha mensaje',
        'lastMessage': 'Último mensaje chat',
        'message': 'Mensaje',
        'replyDate': 'Fecha respuesta',
        'lastPost': 'Último foro con respuesta',
        'nextEvent': 'Próximo evento',
        'name': 'Nombre',
        'description': 'Descripción',
        'active': 'Activa',
        'type': 'Tipo',
        'nextEvents': 'Próximos eventos',
        'lastFiles': 'Últimos documentos',
        'lastMessages': 'Últimos mensajes',
        'users': 'Usuarios',
        'unnamedUser': 'Usuario sin nombre',
        'noEvents': 'No hay eventos para mostrar',
        'noFiles': 'No hay archivos para mostrar',
        'noMessages': 'No hay mensajes para mostrar',
        'noUsers': 'No hay usuarios para mostrar',
        'access': 'Acceder',
        'newArea': 'Nueva Área',
        'email': 'Email',
        'rol': 'Rol',
        'memberUsers': 'Usuarios miembros',
        'newUser': 'Añadir nuevo usuario',
        'editRole': 'Editar rol',
        'pregunta-borrar-usuario-area': '¿ Está seguro que quiere eliminar el usuario del área ?',
        'pregunta-abandonar-usuario-area': '¿ Está seguro que desea abandonar el área ?',
        'abandonedArea': 'Ha abandonado el área',
        'leaveArea': 'Abandonar área',
        'rowsPage': 'Filas por página',
        'activated': 'Área Activa',
        'disabled': 'Área Desactivada',
        'showActive': 'Mostrar Áreas Activas',
        'showInactive': 'Mostrar Áreas Desactivadas',
    },
    'foro': {
        'forum-resume': 'Últimas interacciones del foro',
        'noForum-resum': 'No hay post ni respuestas para mostrar',
        'foro-date-creation': 'Fecha de creación:',
        'reply-placeholder': 'Responda aquí',
        'replys': 'Respuestas',
        'last-reply': 'Última respuesta',
        'new-reply': 'Nueva respuesta en',
        'new-post': 'Nuevo post'
    },
    'roles-collaborative-area': {
        'OwnerCollaborativeArea': 'Propietario Área Colaborativa',
        'CollaboratorCollaborativeArea': 'Colaborador en Área Colaborativa',
        'GuessCollaborativeArea': 'Invitado en Área Colaborativa',
    },
    'types-collaborative-area': {
        'PublicArea': 'Área pública',
        'WorkGroups': 'Grupo de trabajo',
        'PrivateArea': 'Área privada'
    },
    'offers-demands': {
        'myOffersDemands': 'Mis ofertas y demandas',
        'matchingOfferDemand': 'Matching Oferta/Demanda',
        'code': 'Código',
        'description': 'Descripción',
        'type': 'Tipo',
        'value': 'Valor',
        'category1': 'Categoría 1',
        'category2': 'Categoría 2',
        'category3': 'Categoría 3',
        'category4': 'Categoría 4',
        'numMatching': 'Nº matching',
        'hasSynergies': 'Tiene Sinergias',
        'interested': 'Me interesa',
        'oneInterested': 'El otro usuario ya ha indicado que esta interesado en el matching',
        'bothInterested': 'Ambas partes están interesadas ¿Quieres crear el área?',
        'createArea': 'Crear área colaborativa',
        'accessArea': 'Accede al área colaborativa',
        'result': 'Resultado',
        'label': 'Etiqueta',
        'information': 'Información',
        'units': 'Unidades',
        'company': 'Empresa',
        'location': 'Ubicación',
        'offer': 'Oferta',
        'demand': 'Demanda',
        'postalCode': 'Código postal',
        'photo': 'Foto',
        'name': 'Nombre',
        'amount': 'Cantidad',
    },
    'buscador-avanzado': {
        'buscador': 'Buscador Avanzado',
    },
    'account': {
        'cuenta': 'Cuenta',
        'nombre': 'Nombre',
        'razon-social': 'Razón Social',
        'direccion': 'Dirección',
        'cnae': 'Código CNAE',
        'asociacion': 'Asociación',
        'usuario': 'Usuario',
        'email': 'Email',
        'postal': 'Código Postal',
        'localidad': 'Localidad',
        'provincia': 'Provincia',
        'pais': 'Pais',
        'confirmar': '¿Está seguro de que desea guardar los nuevos datos?',
        'success': 'Datos guardados con éxito',
        'error': 'No se han podido guardar los datos',
    },
    'enum-plantillas': {
        'Numérico': 'Numérico',
        'Decimal': 'Decimal',
        'Fecha': 'Fecha',
        'Verdadero/Falso': 'Verdadero/Falso',
        'Fichero': 'Fichero',
        'Imagen': 'Imagen',
        'Listado': 'Listado',
        'Rango': 'Rango',
        'Ler': 'Ler',
        'Cnae': 'Cnae',
        'Sector': 'Sector',
        'Texto': 'Texto'
    },
    'enum-launch-type': {
        'Automatic': 'Automático',
        'Manual': 'Manual',
        'AutomaticAndManual': 'Automático y Manual'
    },
    'enum-user-role': {
        'Admin': 'Administrador',
        'EntityUser': 'Usuario Entidad',
        'ExpertUser': 'Usuario Experto'
    },
    'schedule': {
        'delete-confirm': '¿Está seguro de que desea borrar este evento?',
        'delete': 'No se ha podido borrar el evento',
        'upload': 'No se ha podido actualizar este eventos',
        'create': 'No se ha podido crear el evento',
        'show': 'No se ha podido cargar los eventos',
    },
    'noticia': {
        'noticia': 'Notícia',
        'noticias': 'Notícias',
        'titular': 'Título',
        'autor': 'Autor',
        'etiquetas': 'Etiquetas',
        'resumen': 'Resumen',
        'mancheta': 'Mancheta',
        'categoria': 'Categoría',
        'instituto': 'Instituto',
    }
};
